import { createAction } from '@reduxjs/toolkit';
import { AppThunk } from '@packages/shared/core/common/store';
import { UserLocation } from '../entities';

export const fetchLocationPending = createAction('location/FETCH_LOCATION/pending');
export const fetchLocationSucceed = createAction<UserLocation>('location/FETCH_LOCATION/succeed');
export const fetchLocationFailed = createAction('location/FETCH_LOCATION/failed');

export const fetchLocationRequest =
  (): AppThunk =>
  async (dispatch, getState, { locationService }) => {
    dispatch(fetchLocationPending());

    try {
      const location = await locationService.getLocation();
      dispatch(fetchLocationSucceed(location));
    } catch {
      dispatch(fetchLocationFailed());
    }
  };
